import { type EventRuleDto, useEventUpdateEventRules } from "@crowdcoursing/api/openapi";
import { useState } from "react";

interface UseEventRulesProps {
  eventId: string;
  rules: EventRuleDto[];
}

export const useEventRules = ({ eventId, rules }: UseEventRulesProps) => {
  const [isRulesDialogOpen, setIsRulesDialogOpen] = useState(false);
  const updateEventRules = useEventUpdateEventRules();

  const handleManageRules = () => {
    setIsRulesDialogOpen(true);
  };

  const handleSaveRules = async (updatedRules: EventRuleDto[]) => {
    try {
      await updateEventRules.mutateAsync({
        body: {
          eventId,
          rules: updatedRules,
        },
        pathParams: {
          eventId,
        },
      });
      setIsRulesDialogOpen(false);
    } catch (error) {
      console.error("Failed to update event rules:", error);
    }
  };

  return {
    handleManageRules,
    handleSaveRules,
    isRulesDialogOpen,
    onCloseRulesDialog: () => setIsRulesDialogOpen(false),
    rules,
  };
};
